//CORE
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChildren,
} from "@angular/core";

//SERVICE
import { AppService } from "../services/app.service";
import { ProfilePageService } from "../services/profile-page.service";

//MODEL
import { Badge } from "../model/badge";
import { Topbar } from "../model/topbar";
import { environment } from "../../environments/environment";
import { Location } from "@angular/common";
import { SharedService } from "../services/shared.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-profile-page",
  templateUrl: "./profile-page.component.html",
  styleUrls: ["./profile-page.component.css"],
  providers: [ProfilePageService],
})
export class ProfilePageComponent implements OnInit {
  header: Topbar;
  headerList: Topbar[];

  username: string = "-";

  //Badges
  badges: Badge[] = [];
  selectedBadge: Badge = null;

  key: string = localStorage.getItem("key");

  shouldShowBadgeModal = true;

  relearnit_base_url = environment.relearnit_base_url;

  constructor(
    private appService: AppService,
    private router: Router,
    private sharedService: SharedService,
    private profileService: ProfilePageService
  ) {
    // recupero info corsi
    this.headerList = JSON.parse(localStorage.getItem("headerList"));
    this.header = JSON.parse(localStorage.getItem("header"));

    if (this.header === null) {
      this.router.navigate(["/homepage"]);
      return;
    }
    this.username = this.header.username || "-";

    this.profileService
      .getBadges(this.header.user_id, this.header.course_id, this.key)
      .subscribe((result) => {
        this.badges = result;
      });
  }

  ngOnInit() {
    this.sharedService.headerUpdated.subscribe(async (headerList: Topbar[]) => {
      this.headerList = headerList;
      for (const header of this.headerList) {
        if (header.course_id == this.header.course_id) {
          this.header = header;
          break;
        }
      }
      localStorage.setItem("header", JSON.stringify(this.header));

      if (this.header == null) {
        await this.router.navigate(["/homepage"]);
        return;
      }
    });
  }

  showBadgeModal(badge: Badge) {
    if (badge.status == 1) {
      this.shouldShowBadgeModal = true;
      this.selectedBadge = badge;
      document.querySelector("body").style.overflow = "hidden";
    }
  }

  closeBadgeModal() {
    this.shouldShowBadgeModal = false;
    this.selectedBadge = null;
    document.querySelector("body").style.overflow = "auto";
  }

  sanitizeCourseTitle(courseName: string){
    let title = courseName;
    title = title.replace('Amministratore - ', '');
    title = title.replace('amministratore - ', '');
    title = title.replace('Dipendenti - ', '');
    title = title.replace('dipendenti - ', '');
    title = title.replace('Negozio - ', '');
    title = title.replace('negozio - ', '');
    title = title.replace('PGS - ', '');
    title = title.replace('pgs - ', '');
    title = title.replace('VLT - ', '');
    title = title.replace('vlt - ', '');
    title = title.replace('Noleggiatore - ', '');
    title = title.replace('noleggiatore - ', '');
    title = title.replace('Snaipay PVR - ', '');
    title = title.replace('Dipendenti Snaitech - ', '');
    title = title.replace('dipendenti snaitech - ', '');
    title = title.replace('HR Amministratore - ', '');
    title = title.replace('hr amministratore - ', '');

    return title;
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-page/profile-page.component.ts